import * as React from "react"
import { SVGProps } from "react"
const OfflineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g fill="#FF2626" stroke="#FF2626" strokeWidth={0.514} clipPath="url(#a)">
      <path d="M1.308 7.574a.504.504 0 0 1 .431-.103c4.469.767 7.989 4.465 8.53 8.935h-.002a.537.537 0 0 1-.517.64h-.044a.605.605 0 0 1-.38-.122.492.492 0 0 1-.183-.37c-.471-4.021-3.597-7.276-7.579-7.961l-.008-.002-.01-.002a.658.658 0 0 1-.352-.213.507.507 0 0 1-.1-.451.657.657 0 0 1 .214-.35Zm.495 4.08.01.003v.001c2.16.644 3.81 2.434 4.358 4.674h-.002c.08.281-.104.588-.405.663l-.032.007h-.119a.587.587 0 0 1-.552-.396l-.003-.011-.003-.012a5.212 5.212 0 0 0-3.565-3.816v-.002c-.326-.09-.467-.416-.395-.704a.563.563 0 0 1 .597-.423l.11.016Z" />
      <path d="m1.712 3.681.016.002c6.501.807 11.655 6.14 12.283 12.64h-.003a.536.536 0 0 1-.517.636h-.044a.605.605 0 0 1-.381-.124.494.494 0 0 1-.183-.376v.001C12.32 10.42 7.572 5.544 1.576 4.81l-.016-.002-.015-.004c-.32-.08-.459-.385-.459-.601 0-.18.114-.313.213-.388a.672.672 0 0 1 .397-.134h.015ZM16.395.941c.154 0 .295.067.402.175a.568.568 0 0 1 .174.402.567.567 0 0 1-.174.401L14.78 3.938l2.018 2.019a.568.568 0 0 1 .174.402.567.567 0 0 1-.174.401.593.593 0 0 1-.402.164.592.592 0 0 1-.402-.164l-2.018-2.018-2.019 2.018a.594.594 0 0 1-.402.164.592.592 0 0 1-.401-.164.567.567 0 0 1-.175-.401.57.57 0 0 1 .175-.402l2.017-2.019-2.017-2.019a.568.568 0 0 1-.175-.4.57.57 0 0 1 .175-.403.568.568 0 0 1 .401-.174c.155 0 .295.066.402.174l2.019 2.018 2.018-2.018a.568.568 0 0 1 .402-.174Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default OfflineIcon;